import type { InventoryStatusProps } from '@components/InventoryStatus';
import { useProductItemThemeSettings } from '@providers/ThemeProvider/Provider/ProductItemThemeSettings';
import { useMemo } from 'react';

export type InventoryStatusPropsMapSettings = Omit<InventoryStatusProps, 'inventory'>;

export const useConnectInventoryStatus = () => {
  const settings = useProductItemThemeSettings();
  const productInventoryStatusSettings = settings.productInfo?.elements?.inventoryStatus;

  const props: InventoryStatusPropsMapSettings = useMemo(() => {
    if (!productInventoryStatusSettings) return {};

    return {
      ...productInventoryStatusSettings,
    };
  }, [productInventoryStatusSettings]);

  return {
    props,
  };
};
